// Usage:
// <ContextMenu id={item.id} parentRef={contextMenuRef}>
//   <PopupMenu.Item title="Edit Description" onClick={startEditing} />
// </ContextMenu>

import React, { Fragment } from "react";

import useContextMenu from "../../hooks/useContextMenu";
import PopupMenu from "../PopupMenu";

type Props = {
  id: string;
  parentRef: React.RefObject<HTMLElement>;
  children: React.ReactNode;
  onOpenMenu?: (e: React.MouseEvent<HTMLDivElement>) => boolean;
};
const ContextMenu: React.FC<Props> = ({ id, parentRef, onOpenMenu, children }) => {
  const { contextMenuXPos, contextMenuYPos, contextMenuOpen, handleContextMenuClose } =
    useContextMenu({ itemRef: parentRef, onOpenMenu });
  const contextMenuSource = `${id}-context-menu`;
  return (
    <Fragment>
      <PopupMenu.ContextMenuAnchor
        xPos={contextMenuXPos}
        yPos={contextMenuYPos}
        data-popup-source={contextMenuSource}
      />
      {contextMenuOpen && (
        <PopupMenu
          data-testid="context-menu-popup"
          source={contextMenuSource}
          close={handleContextMenuClose}
          vPos="floatBelow"
          hPos="alignLeft">
          {children}
        </PopupMenu>
      )}
    </Fragment>
  );
};

export default ContextMenu;
